import React from 'react'

const menuicon = () => (
    <svg version="1.1" xmlns="https://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 61.3 61.3">
        <line className="st1" x1="0" y1="30.7" x2="50" y2="30.7"/>
        <line className="st1" x1="0" y1="49.9" x2="50" y2="49.9"/>
        <line className="st1" x1="0" y1="11.4" x2="50" y2="11.4"/>
    </svg>
);
export default menuicon;